import { useRouter } from '@tanstack/react-router';
import { AlertCircle, RotateCw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorPageProps {
  error?: Error;
  reset?: () => void;
}

export function ErrorPage({ error, reset }: ErrorPageProps) {
  const router = useRouter();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mb-6">
        <AlertCircle className="h-8 w-8 text-destructive" />
      </div>
      <h1 className="text-2xl font-bold text-foreground mb-2">Something went wrong</h1>
      <p className="text-center text-muted-foreground max-w-md mb-6">
        {error?.message || 'An unexpected error occurred. Please try again later.'}
      </p>
      <div className="flex gap-4">
        {reset ? (
          <Button onClick={reset} variant="default" className="gap-2">
            <RotateCw className="h-4 w-4" />
            Try Again
          </Button>
        ) : (
          <Button onClick={() => router.invalidate()} variant="default" className="gap-2">
            <RotateCw className="h-4 w-4" />
            Reload
          </Button>
        )}
        <Button onClick={() => (window.location.href = '/')} variant="outline" className="gap-2">
          <Home className="h-4 w-4" />
          Go Home
        </Button>
      </div>
    </div>
  );
}
